import { createSelector } from "reselect";
const selector = (state) => state.pendingCharges;

export default createSelector([selector], (data) => data);